import React from "react"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined"
import { Member } from "./MembersTable"

interface DeactivateMemberDialogProps {
  member: Member | null
  title: string
  bodyText: React.ReactNode
  buttonText: string
  onConfirm: (member: Member) => void
  onClose: () => void
}

export const DeactivateMemberDialog = ({ member, title, bodyText, buttonText, onConfirm, onClose }: DeactivateMemberDialogProps) => {
  return (
    <Dialog
      open={!!member}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: "25px", pt: 4, px: 4 } }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1.5, fontSize: "32px", fontWeight: 600, px: 0 }}>
        <PersonOffOutlinedIcon sx={{ fontSize: 36 }} />
        {title}
      </DialogTitle>
      <DialogContent sx={{ px: 0, py: 2 }}>
        <Typography variant="body1">
          {bodyText}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 0, pb: 2, pt: 3, gap: 0.5 }}>
        <Button variant="contained" color="primary" onClick={() => member && onConfirm(member)}>
          {buttonText}
        </Button>
        <Button variant="outlined" color="secondary" onClick={onClose}>
          Dismiss
        </Button>
      </DialogActions>
    </Dialog>
  )
}
